import React from "react";
import { Box } from "@mui/material";
import { VIRTUAL, VIRTUAL_LABEL } from "../utils/locations";

/**
 * Native dropdown of the tenant's sites with "Virtual" always offered first.
 * virtualOnly (a 100% virtual class) leaves Virtual as the only choice.
 * legacyText: an existing session's old free-text location that matches no site - kept selectable so editing doesn't lose it.
 */
export default function LocationSelect({ value, onChange, sites, virtualOnly = false, legacyText, placeholder = "Select a location…", sx, ...rest }) {
  return (
    <Box component="select" value={virtualOnly ? VIRTUAL : (value ?? "")} disabled={virtualOnly}
      onChange={(e) => onChange(e.target.value)} sx={sx} {...rest}>
      {!virtualOnly && <option value="">{placeholder}</option>}
      <option value={VIRTUAL}>{VIRTUAL_LABEL}</option>
      {!virtualOnly && legacyText && <option value={`legacy:${legacyText}`}>{legacyText}</option>}
      {!virtualOnly && sites.map((s) => <option key={s.id} value={String(s.id)}>{s.name}</option>)}
    </Box>
  );
}
